import { Circle, Icon, SquareProps } from "@chakra-ui/react";
import React from "react";
import { HiCheck } from "react-icons/hi";

interface RadioCircleProps extends SquareProps {
  isCompleted: boolean;
  isActive: boolean;
}

export const StepCircle = (props: RadioCircleProps) => {
  const { isCompleted, isActive } = props;
  return (
    <Circle
      size="8"
      bg={isCompleted ? "var(--accent)" : "inherit"}
      borderWidth={isCompleted ? "0" : "2px"}
      borderColor={isActive ? "accent" : "inherit"}
      {...props}
    >
      {isCompleted ? (
        <Icon as={HiCheck} color="fg.inverted" boxSize="5" />
      ) : (
        <Circle bg={isActive ? "var(--accent)" : "border"} size="3" />
      )}
    </Circle>
  );
};
